module.exports = __webpack_public_path__ + "img/youtube-kreis.0c9dc996.svg";